module.exports = __webpack_public_path__ + "img/weixin.bc955e18.png";